import React from 'react'

const TextArea = ({placeholder,setValue,height,width,value}) => {
  return (
    <div>
      <textarea
        placeholder={placeholder || null}
        value={value ? value :  null}
        className="text_box"
        onChange={(e) => setValue(e.target.value)}
        style={{
           height: height ? `${height}px` : '150px',
          width: width ? `${width}px`:'250px',
          border: '1px solid rgb(226, 226, 226)',
          borderRadius: '10px',
          margin: '0',
          padding: '5px',
          resize: 'none', 
          overflow: 'auto', 
          verticalAlign: 'top',
        }}
      />
    </div>
  )
}

export default TextArea
